import Badge from '@components/Badge';
import Column from '@components/Column';
import CtaLayout from '@components/CtaLayout';
import Header from '@components/Header';
import Loading from '@components/Loading';
import styled from '@emotion/styled';
import { EventStatusBadgeColor } from '@models/event/extension';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import BoardDetailHeader from '../components/BoardDetailHeader';
import BoardHtmlContent from '../components/BoardHtmlContent';
import AttendanceNote from './components/AttendanceNote';
import EventFooter from './components/EventFooter';
import Sheet from './components/Sheet';
import StampPanel from './components/StampPanel';
import useEvent from './hooks/useEvent';

interface Params {
    eventId: string;
}

declare module '@stackflow/config' {
    interface Register {
        EventActivity: Params;
    }
}

const EventActivity: ActivityComponentType<'EventActivity'> = ({ params }) => {
    const { eventId } = params;
    const event = useEvent(eventId);
    const { t } = useTranslation('event');
    const { t: tBoard } = useTranslation('board');
    return (
        <AppScreen >
            <CtaLayout header={<Header title={t('header.title')}/>}
                footer={<EventFooter eventId={eventId}/>} >
                {event ? (
                    <Fragment>
                        <BoardDetailHeader title={event.title}
                            badge={(
                                <Badge color={EventStatusBadgeColor[event.status]}>
                                    {tBoard(`eventStatus.${event.status}`)}
                                </Badge>
                            )}
                            startAt={event.startAt}
                            endAt={event.endAt} />
                        <Container spacing={2} fullWidth>
                            <Sheet eventId={eventId} />
                            <StampPanel eventId={eventId} />
                            <BoardHtmlContent content={event.content}/>
                            <AttendanceNote eventId={eventId} />
                        </Container>
                    </Fragment>
                ) : (<Loading/>)}
            </CtaLayout>
        </AppScreen>
    );
};

const Container = styled(Column)`
    padding-bottom: 64px;
`;

export default EventActivity;
